module.exports = __webpack_public_path__ + "static/media/right2.2aead770.png";